"use client"
import React, { useCallback, useEffect, useState } from 'react'
import { WindowProps, useChatContext } from "@copilotkit/react-ui";
import './styles.module.scss'
import { AnimatePresence, motion } from 'framer-motion'
import { Box } from '@mui/material';
const Window = ({ children }: WindowProps) => {
    const { open, setOpen } = useChatContext();
    const [width, setWidth] = useState(856);
    const [isResizing, setIsResizing] = useState(false);
    const [justResized, setJustResized] = useState(false);
    const startResizing = useCallback(() => {
        setIsResizing(true);
    }, []);

    const stopResizing = useCallback(() => {
        setIsResizing(false);
        setJustResized(true);
        localStorage.setItem('copilot-sidebar-width', width.toString());
    }, [width]);

    useEffect(() => {
        if (justResized) {
            const timeout = setTimeout(() => setJustResized(false), 100);
            return () => clearTimeout(timeout);
        }
    }, [justResized]);

    const resize = useCallback((mouseMoveEvent: MouseEvent) => {
        if (isResizing) {
            const viewportWidth = window.innerWidth;
            const newWidthPx = viewportWidth - mouseMoveEvent.clientX;
            const newPercent = (newWidthPx / viewportWidth) * 100;
            if (newPercent >= 30 && newPercent <= 85) {
                setWidth(newWidthPx);
            }
        }
    }, [isResizing]);

    useEffect(() => {
        // Khôi phục kích thước từ localStorage hoặc sử dụng phần trăm
        const savedWidth = localStorage.getItem('copilot-sidebar-width');
        if (savedWidth) {
            setWidth(parseInt(savedWidth));
        }
    }, []);

    useEffect(() => {
        if (isResizing) {
            window.addEventListener('mousemove', resize);
            window.addEventListener('mouseup', stopResizing);
        }
        return () => {
            window.removeEventListener('mousemove', resize);
            window.removeEventListener('mouseup', stopResizing);
        };
    }, [isResizing, resize, stopResizing]);

    // if (!open) return null;
    return (
        <div
            className={`${isResizing ? 'no-select' : ''} fixed inset-0 flex items-center justify-end z-50 ${open ? 'bg-black/50' : 'pointer-events-none'
                }`}
            onClick={() => {
                if (isResizing || justResized) return;
                setOpen(false);
            }}
        >
            <AnimatePresence>
                {
                    open && (
                        <motion.div
                            className="h-full"
                            initial={{ x: "100%" }}
                            animate={{ x: 0 }}
                            exit={{  x: "100%" }}
                            transition={{ duration: 0.2, ease: "easeInOut" }}
                        >
                            <Box
                                className={` bg-white h-full flex flex-col transform transition-transform duration-200 ${open ? 'translate-x-0' : 'translate-x-full'
                                    }`}
                                sx={{ width: {
                                    xs: '100vw',
                                    sm: `${width}px`,
                                } }}
                                onClick={e => e.stopPropagation()}
                            >
                                <div
                                    className="hidden absolute left-0 top-0 bottom-0 w-3 sm:flex items-center justify-center cursor-ew-resize z-20"
                                    style={{ left: '-10px', width: '20px' }}
                                    onMouseDown={startResizing}
                                >
                                    <span
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: 32,
                                            width: 16,
                                            borderRadius: 8,
                                            background: '#e5e7eb',
                                        }}
                                    >
                                        <span style={{ fontSize: 18, color: '#888' }}>⋮</span>
                                    </span>
                                </div>
                                <div className="flex flex-col overflow-hidden h-full">
                                    {children}
                                </div>
                            </Box>
                        </motion.div>
                    )
                }
            </AnimatePresence>
        </div>
    )
}

export default Window